import React from "react";

export default function TrashWindow({
  items,
  onRestore,
  onEmptyTrash,
  onClose,
}) {
  return (
    <section className="mac-window mac-trashWindow" role="dialog" aria-label="Trash">
      <div className="mac-windowTitleBar">
        <button
          type="button"
          className="mac-windowClose"
          onPointerDown={(e) => e.stopPropagation()}
          onClick={(e) => {
            e.stopPropagation();
            onClose?.();
          }}
          aria-label="Close Trash"
          title="Close"
        >
          ×
        </button>
        <div className="mac-windowTitle" title="Trash">
          Trash
        </div>
        <div className="mac-windowSpacer" aria-hidden="true" />
      </div>

      <div className="mac-windowBody mac-trashBody">
        <div className="mac-trashHeader">
          <div className="mac-trashCount">
            {items.length} item{items.length === 1 ? "" : "s"}
          </div>
          <button
            type="button"
            className="mac-button mac-buttonDanger"
            disabled={items.length === 0}
            aria-disabled={items.length === 0}
            onClick={() => onEmptyTrash?.()}
            title="Permanently delete all trash"
          >
            Empty Trash…
          </button>
        </div>

        {items.length === 0 ? (
          <div className="mac-trashEmpty">Trash is empty.</div>
        ) : (
          <ul className="mac-trashList" aria-label="Trashed memos">
            {items.map((m) => (
              <li key={m.id} className="mac-trashRow">
                <span className="mac-trashName" title={m.name}>
                  {m.name}
                </span>
                <button
                  type="button"
                  className="mac-button"
                  onClick={() => onRestore?.(m.id)}
                >
                  Put Back
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>
    </section>
  );
}

